import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 18v-11a2 2 0 0 1 2 -2h.5a.5 .5 0 0 0 .5 -.5a.5 .5 0 0 1 .5 -.5h3a.5 .5 0 0 1 .5 .5a.5 .5 0 0 0 .5 .5h.5a2 2 0 0 1 2 2v11a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2","key":"svg-0"}],["path",{"d":"M12.667 8l-2.667 4h4l-2.667 4","key":"svg-1"}]]

const IconBatteryVerticalCharging = createReactComponent('outline', 'battery-vertical-charging', 'BatteryVerticalCharging', __iconNode);

export default IconBatteryVerticalCharging;